import './Footer.css';

function Footer() {
  return (
    <footer className="footer" id="footer">
      <p>© 2026 Love co-creation.</p>
    </footer>
  );
}

export default Footer;
